import { render, staticRenderFns } from "./IP_FindingSummaryCombined.vue?vue&type=template&id=42d0439a&scoped=true&"
import script from "./IP_FindingSummaryCombined.vue?vue&type=script&lang=js&"
export * from "./IP_FindingSummaryCombined.vue?vue&type=script&lang=js&"
import style0 from "./IP_FindingSummaryCombined.vue?vue&type=style&index=0&id=42d0439a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d0439a",
  null
  
)

export default component.exports